export const EDITING_RECORD_START = "EDITING_RECORD_START";
export const EDITING_RECORD_START_SUCCESS = "EDITING_RECORD_START_SUCCESS";
export const EDITING_RECORD_START_ERROR = "EDITING_RECORD_START_ERROR";
export const EDITING_RECORD_END = "EDITING_RECORD_END";
export const EDITING_RECORD_END_SUCCESS = "EDITING_RECORD_END_SUCCESS";
export const EDITING_RECORD_END_ERROR = "EDITING_RECORD_END_ERROR";